import KeyValuePair from '@/modules/core/support/KeyValuePair'
import ProductTranslation from '@/modules/product/model/ProductTranslation';
import { SEOPositionable, Metadata } from '@/modules/seo/types';

/**
 * Producto de Unigest
 *
 * @author Alejandro G. Riaño <agutierrez@softcontrol.es>
 */
export default class Product implements SEOPositionable {
    public id = ''
    private _name = ''
    public pvp = 0
    public pvpIva = 0
    public image = ''
    public largeImage = ''
    public translations: ProductTranslation[] = []
    public visible = false
    public seo = new Metadata()

    /**
     * Nombre del producto
     */
    get name (): string {
        const translation = this.translate('es')
        if (!translation) {
            return this._name
        }

        return translation.name
    }

    /**
     * Añade una nueva traducción y si ya existe la sustituye
     *
     * @param translation
     */
    public addTranslation (translation: ProductTranslation) {
        const index = this.translations.findIndex(t => t.locale === translation.locale)
        if (index < 0) {
            this.translations.push(translation)

            return this
        }

        this.translations.splice(index, 1, translation)

        return this
    }


    /**
     * Obtiene una traducción
     *
     * @param locale
     */
    public translate (locale: string): ProductTranslation | null {
        return this.translations.find(t => t.locale === locale) || null
    }

    public static deserialize (data: KeyValuePair): Product {
        const product = new this()
        product.id = data.id
        product._name = data.name || ''
        product.pvp = data.pvp || 0
        product.pvpIva = data.pvp_iva || 0
        product.image = data.image || ''
        product.visible = data.visible || false

        if (data.seo) {
            product.seo = Metadata.deserialize(data.seo)
        }

        const translations = data.translations || []
        if (translations) {
            product.translations = translations.map((t: any) => ProductTranslation.deserialize(t))
        }

        return product
    }

    public serialize (): KeyValuePair {
        return {
            visible: this.visible,
            pvp: this.pvp,
            translations: this.translations.map(t => t.serialize()),
            seo: this.seo.serialize(),
        }
    }
}
